const labelText = {
	key: `container.label`,
	text: "Media player"
};
//#endregion
export { labelText };

//# sourceMappingURL=container.js.map